import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import {
  FDBodyText,
  FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import MetaCollectionFormAccordion from 'Components/UI/Meta/MetaForm/Components/MetaCollectionFormAccordion';
import metaOverrideSet from './metaOverrideSet';
import { StepLayout } from './stepLayout';

const Layout = () => {
  const {
    resource,
    onSubmit, saving, handleChange,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  const onClose = () => {
    clearModalCollection();
  };

  return (
    <>
      <DialogTitle value="Announcement" />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={2}>
          <MetaLayoutRemainingFields noAccordion />
          <FDStack direction="row" justifyContent="space-between" spacing={2} wrap>
            <FDBodyText value="Steps" />
            <FDPrimaryActionButton
              onClick={() => handleChange('steps', resource.attr('steps').create({ addToCollection: true }))}
              label="Add"
              icon="add"
              iconPosition="start"
            />
          </FDStack>
          <MetaCollectionFormAccordion
            collection={resource.attr('steps')}
            metaOverrideSet={metaOverrideSet}
            titleGenerator={() => 'Step'}
            FormProps={{
              noIndividualSubmitButtons: true,
              noIndividualDeleteButtons: true,
              layout: StepLayout,
            }}
          />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDSecondaryActionButton label={'Cancel'} onClick={onClose} />
        <FDPrimaryActionButton
          loading={saving}
          label={'Save'}
          onClick={async () => {
            try {
              await onSubmit({ rejectOnError: true });
              onClose();
            } catch {
              // There's already an error being shown to the member
            }
          }}
        />
      </DialogActions>
    </>
  );
};

export default Layout;
